import { render } from "./HzbaForm.vue?vue&type=template&id=f359b15c&scoped=true&ts=true"
import script from "./HzbaForm.vue?vue&type=script&lang=ts"
export * from "./HzbaForm.vue?vue&type=script&lang=ts"

import "./HzbaForm.vue?vue&type=style&index=0&id=f359b15c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f359b15c"]])

export default __exports__